import { Grid, TextField } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { gridSpacing } from "store/constant";
import Loader from "ui-component/Loader";
import SubCard from "ui-component/cards/SubCard";

const Profile = () => {
  const { data, isLoading } = useSelector(
    (state) => state.dashboard.photograph
  );

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Grid container spacing={gridSpacing}>
      <Grid item sm={12} md={12}>
        <SubCard title={<FormattedMessage id="profile.details" />}>
          <Grid container spacing={gridSpacing}>
            <Grid item xs={12}>
              <TextField
                id="outlined-basic1"
                disabled
                fullWidth
                label={<FormattedMessage id="general.name" />}
                defaultValue={data.name}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                id="outlined-basic6"
                disabled
                fullWidth
                label={<FormattedMessage id="general.email" />}
                defaultValue={data.email}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                id="outlined-basic4"
                disabled
                fullWidth
                label={<FormattedMessage id="general.address" />}
                defaultValue={data.street_address}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                id="outlined-basic5"
                disabled
                fullWidth
                label={<FormattedMessage id="general.city" />}
                defaultValue={data.locality}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                id="outlined-basic7"
                disabled
                fullWidth
                label={<FormattedMessage id="general.postal_code" />}
                defaultValue={data.postal_code}
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                id="outlined-basic8"
                disabled
                fullWidth
                label={<FormattedMessage id="general.country" />}
                defaultValue={data.country}
              />
            </Grid>
          </Grid>
        </SubCard>
      </Grid>
      <Grid item sm={12} md={12}>
        {data.client_id && (
          <SubCard title={<FormattedMessage id="profile.api" />}>
            <Grid item xs={12}>
              <FormattedMessage id="profile.api_access" />
            </Grid>
            <Grid item xs={12} mt={4}>
              <FormattedMessage id="profile.client_id" /> &nbsp;
              <strong>{data.client_id}</strong>
              <br />
              <FormattedMessage id="profile.client_secret" /> &nbsp;
            </Grid>
          </SubCard>
        )}
      </Grid>
    </Grid>
  );
};

export default Profile;
